import React from "react";
import {Card, CardActions, CardContent, Typography} from "@mui/material";
import {UserAvatar} from "@atttomyx/react-components";
import "./userCard.css";

const UserCard = (props) => {
    const { user, children } = props;

    return <Card className="user-card" raised={true}>
        <CardContent>
            <UserAvatar user={user} mode="right"/>
            <Typography variant="caption" component="div" className="role">
                ({user.roles.admin ? "admin" : user.settings.type.toLowerCase()})
            </Typography>
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default UserCard;
